import React from 'react';

/**
 * Phase 3.E — small "X days without fault" line on the gate detail.
 *
 * Five visual states driven by the ``fault_history`` payload from
 * the gate detail endpoint:
 *
 *   - active fault → "תקלה פעילה" (red), grabs attention
 *   - never had a fault → "טרם נצפתה תקלה" (neutral grey)
 *   - 0 days (fault earlier today) → "תקלה היום" (warm orange)
 *   - short streak (1-29 days) → "X ימים ללא תקלה" (grey)
 *   - long streak (30+ days) → "X ימים ללא תקלה" (subtle green)
 *
 * The intent is reassurance, not alarm — the colours stay quiet so
 * the badge fits next to the cycle / model stats without dominating
 * the panel.
 */
function FaultHistoryBadge({ faultHistory }) {
  if (!faultHistory) return null;

  const { has_active_fault, days_without_fault, last_fault_at } = faultHistory;

  let text;
  let bg;
  let fg;
  let border;

  if (has_active_fault) {
    text = 'תקלה פעילה';
    bg = '#fef2f2';
    fg = '#b91c1c';
    border = '#fecaca';
  } else if (last_fault_at == null) {
    text = 'טרם נצפתה תקלה';
    bg = '#f3f4f6';
    fg = '#4b5563';
    border = '#e5e7eb';
  } else if (days_without_fault === 0) {
    text = 'תקלה היום';
    bg = '#fffbeb';
    fg = '#92400e';
    border = '#fde68a';
  } else if (days_without_fault >= 30) {
    text = `${days_without_fault} ימים ללא תקלה`;
    bg = '#ecfdf5';
    fg = '#047857';
    border = '#a7f3d0';
  } else {
    text = `${days_without_fault} ימים ללא תקלה`;
    bg = '#f3f4f6';
    fg = '#4b5563';
    border = '#e5e7eb';
  }

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '0.2rem 0.65rem',
        background: bg,
        color: fg,
        border: `1px solid ${border}`,
        borderRadius: '999px',
        fontSize: '0.75rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  );
}

export default FaultHistoryBadge;
